export const environment = {
	production: false,
	graphql_uri:
		'https://uhccvwqlr6.execute-api.us-east-2.amazonaws.com/dev/graphql/'
};
